import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class InfrastructureApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Get a list of printer groups. If a group code is provided then return a list of printer groups starting from that group code. If no group code provided then return all of the printer group. There are only a few hundred printer groups out there.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listPrinterGroups(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups'), {
            queryParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Returns a list of printers. If a printer code is provided then a list of printers will be returned starting from that printer code.  If a SIC code is provided, this will be used to filter the results by that location.  If no printer code is provided, then all of the printers will be returned.  There aren't a lot of them, so we will return all of them.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listPrinters(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers'), {
            queryParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Get a list of printers attached to a printer group.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listAttachedPrinters(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups/{printerGroupInstId}/printers'), {
            pathParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Add a new Printer reference.
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    addPrinter(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Create a new Printer Group.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    addPrinterGroup(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Delete a printer reference.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deletePrinter(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/{printerInstId}'), {
            pathParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Update Printer information
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updatePrinter(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Attach a printer to a printer group.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    attachPrinterToGroup(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups/{printerGroupInstId}/printers/{printerInstId}'), {
            pathParams: request,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Remove a printer from a printer group.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    removePrinterFromGroup(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups/{printerGroupInstId}/printers/{printerInstId}'), {
            pathParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Delete a printer group
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deletePrinterGroup(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups/{printerGroupInstId}'), {
            pathParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Update printer group information.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updatePrinterGroup(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/groups'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation will return any submitted printer group or printer codes if they are invalid and do not exist.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Either a printer group code or one or more printer codes are submitted.
     * <br/>
     * <br/>Post-condition:
     * <br/>1. If any of the submitted codes do not exist in the printer table, they are returned as invalid
     * <br/>2. Return standard error message.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    validatePrinterGroupOrPrinterCodes(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/invalid-printercodes'), {
            queryParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service accepts a document and one or more printer names and prints the documents on the specified printers.
     * <br/>#### Pre Condition
     * <br/>Document and printer names are supplied.
     * <br/>#### Post Condition:
     * <br/>Documents are printed on the specified printers
     * <br/>
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    printDocument(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/printers/print-document'), {}, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will send an email message based on the request message.
     * <br/>			The request message must contain at least one email address in 'to' list and 'from' email address  and 'from name'.
     * <br/>
     * <br/>Pre Condition: A valid email address is passed in the 'to' list and 'from' email address and 'from name' is provided along with message subject and text.
     * <br/>
     * <br/>Post Condition: The service will send an email message to the email address mentioned in the 'to' list.
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    sendEmail(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/messages/email'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will create an asynchronous report request to be processed in the background. The service will store the request in a database table as well as write the request to a JMS queue. It returns a unique ID for each successfully created request.
     * <br/>
     * <br/>Pre Condition: Valid Report Name, Report parameter string and teh requester ID is paaed.
     * <br/>
     * <br/>Post Condition: The service creates a report request and returns the unique identifier for the request.
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createAsyncReportRequest(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/reports/request'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Get a list of reference standard codes for a code type.
     * <br/>pre-conditions: a 4 characters code type
     * <br/>post-conditions: return a list of standard codes that match the code type.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listRefStandardCodes(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/reference/codes/{codeType}'), {
            pathParams: request
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Maintain a list of reference standard codes for a code type.
     * <br/>pre-conditions: a 4 characters code type, a list of reference standard codes to create and/or update
     * <br/>post-conditions: return a list of standard codes that match the code type.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    maintainRefStandardCodes(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/reference/codes'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(InfrastructureApiService.InfrastructureApiEndpoint);
    }
}
InfrastructureApiService.ɵfac = function InfrastructureApiService_Factory(t) { return new (t || InfrastructureApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
InfrastructureApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: InfrastructureApiService, factory: InfrastructureApiService.ɵfac });
InfrastructureApiService.InfrastructureApiEndpoint = 'infrastructureApiEndpoint';
/** @nocollapse */
InfrastructureApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfrastructureApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkInfrastructureModule {
}
SdkInfrastructureModule.ɵfac = function SdkInfrastructureModule_Factory(t) { return new (t || SdkInfrastructureModule)(); };
SdkInfrastructureModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkInfrastructureModule });
SdkInfrastructureModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        InfrastructureApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkInfrastructureModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    InfrastructureApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkInfrastructureModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Infrastructure API
 * Version: 1.0
 * Build: Manual
 */
/**
 * Submit either a printer group code or a list of printer codes for validation. Invalid codes will be returned.
 */
class ValidatePrinterGroupOrPrinterCodesResp {
    constructor() {
        /**
         * If present the printer group code is invalid
         */
        this.printerGroupCd = undefined;
        /**
         * If any printer codes are present, they are invalid
         */
        this.printerCd = undefined;
    }
}
/**
 * Submit either a printer group code or a list of printer codes for validation. Invalid codes will be returned.
 */
class ValidatePrinterGroupOrPrinterCodesRqst {
    constructor() {
        /**
         * The printer group code to be validated
         */
        this.printerGroupCd = undefined;
        /**
         * The printer code(s) to be validated
         */
        this.printerCd = undefined;
    }
}
/**
 * Add a  printer response.
 */
class AddPrinterResp {
    constructor() {
        /**
         * The database instance ID of the printer that was added.
         */
        this.printerInstId = undefined;
    }
}
/**
 * Add a printer.The operation will return the instance id when it is created.
 */
class AddPrinterRqst {
    constructor() {
        /**
         * The code and location of the printer.
         */
        this.printer = undefined;
    }
}
/**
 * Attach a printer to a  printer group. There is no return from this operation.
 */
class AttachPrinterToGroupRqst {
    constructor() {
        /**
         * The instance ID of the printer to attach to the given group.
         */
        this.printerInstId = undefined;
        /**
         * The instance ID of the group to which to attach the printer.
         */
        this.printerGroupInstId = undefined;
    }
}
/**
 * Delete a  printer group.
 */
class DeletePrinterGroupRqst {
    constructor() {
        /**
         * The instance ID of the group to be deleted. There is no return for this operation.
         */
        this.printerGroupInstId = undefined;
    }
}
/**
 * Delete printer.
 */
class DeletePrinterRqst {
    constructor() {
        /**
         * The instance ID of the printer to be deleted. There is no return for this operation.
         */
        this.printerInstId = undefined;
    }
}
/**
 * Returns information about the user who is logged in. It includes information about user name, address, and roles as defined in AD
 */
class GetLoggedInUserInfoResp {
    constructor() {
        this.userInfo = undefined;
    }
}
/**
 * A list of printers attached to a printer group
 */
class ListAttachedPrintersResp {
    constructor() {
        /**
         * A repeating list of the printers attached to the group
         */
        this.printer = undefined;
    }
}
/**
 * Get a list of printers attached to a printer group.
 */
class ListAttachedPrintersRqst {
    constructor() {
        /**
         * The printer group instance Id.
         */
        this.printerGroupInstId = undefined;
    }
}
/**
 * A list of printer groups starting with the group code if it was provided. Otherwise, it will be all of the group codes.
 */
class ListPrinterGroupsResp {
    constructor() {
        /**
         * A repeating list of the printer group with information and  without the member printers.
         */
        this.printerGroup = undefined;
        this.auditInfo = undefined;
    }
}
/**
 * Get a list of printer groups. If a group code is provide then return a list of printer groups starting from that group code. If no group code provide then return all of the printer group. There is only a few hundred printer groups out there.
 */
class ListPrinterGroupsRqst {
    constructor() {
        /**
         * The printer group code to be the start of the list if present.
         */
        this.printerGroupCd = undefined;
    }
}
/**
 * Request to return a list of printers where the printer code and SIC code are optional query params.
 */
class ListPrintersRqst {
    constructor() {
        /**
         * The printer code, which will be the start of the list if present.
         */
        this.printerCd = undefined;
        /**
         * The SIC code that will be used to filter the list of printer codes.
         */
        this.sicCd = undefined;
    }
}
/**
 * A list of printers, starting with the printer code if it was provided, will be returned.  If a SIC code was provided, all printers from that location will be returned. Otherwise, all of the printers will be returned.
 */
class ListPrintersResp {
    constructor() {
        /**
         * A list of printers and information about them.
         */
        this.printer = undefined;
    }
}
/**
 * A list of reference standard codes for a code type is returned.
 */
class ListRefStandardCodesResp {
    constructor() {
        /**
         * A repeating list of the Ref Standard Codes with information
         */
        this.refStandardCodes = undefined;
    }
}
/**
 * Get a list of reference standard codes for a code type.
 */
class ListRefStandardCodesRqst {
    constructor() {
        /**
         * A 4 character code type. CTYP is the top level code type. �Use CTYP to navigate through all other code types.
         */
        this.codeType = undefined;
    }
}
/**
 * Update printer group information.
 */
class MaintainRefStandardCodesResp {
    constructor() {
        /**
         * A repeating list of the Ref Standard Codes to be updated, with information
         */
        this.refStandardCodes = undefined;
    }
}
/**
 * Update printer information.
 */
class MaintainRefStandardCodesRqst {
    constructor() {
        /**
         * A repeating list of the updated Ref Standard Codes with information
         */
        this.refStandardCodes = undefined;
    }
}
/**
 * Remove a printer from a printer group.There is no return for this operation.
 */
class RemovePrinterFromGroupRqst {
    constructor() {
        /**
         * The printer to remove from the group
         */
        this.printerInstId = undefined;
        /**
         * The instance ID of the group from which to remove the printer
         */
        this.printerGroupInstId = undefined;
    }
}
/**
 * Update printer group information.
 */
class UpdatePrinterGroupRqst {
    constructor() {
        /**
         * Information to be updated on the printer group. The instance ID must be present. There is no return for this operation.
         */
        this.printerGroupInfo = undefined;
    }
}
/**
 * Update printer information.
 */
class UpdatePrinterRqst {
    constructor() {
        /**
         * Information to be updated a printer. The instance ID must be present. There is no return for this operation.
         */
        this.printerInfo = undefined;
    }
}
/**
 * Add a  printer group response.
 */
class AddPrinterGroupResp {
    constructor() {
        /**
         * The database instance ID of the printer group that was added.
         */
        this.printerGroupInstId = undefined;
    }
}
/**
 * Add a  printer group.
 */
class AddPrinterGroupRqst {
    constructor() {
        /**
         * The group to be added. All fields should be populated except the instance ID which will be returned by this API
         */
        this.printerGroup = undefined;
    }
}
/**
 * An asyncronous report request
 */
class CreateAsyncReportRqst {
    constructor() {
        /**
         * Unique Name for the report
         */
        this.reportName = undefined;
        /**
         * Parameter string to be passed to teh reprort
         */
        this.reportParms = undefined;
        /**
         * Person requesting the report
         */
        this.requesterId = undefined;
    }
}
/**
 * Response to a asynchronous Report Request
 */
class CreateAsyncReportResp {
    constructor() {
        /**
         * Unique Identifier for the report request created
         */
        this.instanceId = undefined;
    }
}
/**
 * Request message to send the email notification
 */
class SendEmailRqst {
    constructor() {
        this.emailMessage = undefined;
        /**
         * Flag that indicates if the email body has html elements so it will display the message properly.
         */
        this.html = undefined;
    }
}
/**
 * The document and a list of printers on which to print them
 */
class PrintDocumentRqst {
    constructor() {
        this.document = undefined;
        this.documentContents = undefined;
        /**
         * The printer code to be the start of the list if present.
         */
        this.printerCd = undefined;
    }
}
/**
 * A named group that associates a set of printers
 */
class PrinterGroup {
    constructor() {
        /**
         * database key for the group
         */
        this.printerGroupInstId = undefined;
        /**
         * The code identifying a particular group of printers
         */
        this.printerGroupCd = undefined;
        /**
         * Description of the group
         */
        this.printerGroupDesc = undefined;
        /**
         * printers associated with this group
         */
        this.printers = undefined;
    }
}
/**
 * A printer code and its location
 */
class Printer {
    constructor() {
        /**
         * The database key for the printer
         */
        this.printerInstId = undefined;
        /**
         * The code identifying a specific printer
         */
        this.printerCd = undefined;
        /**
         * Location of the printer
         */
        this.printerLocation = undefined;
    }
}
/**
 * An object to store ref standard code information
 */
class RefStandardCode {
    constructor() {
        /**
         * A 4 character code for grouping
         */
        this.codeType = undefined;
        /**
         * A value to represent the code.
         */
        this.codeValue = undefined;
        /**
         * A short description of the code. This is normally used to display in the drop down or in the print report.
         */
        this.shortDescription = undefined;
        /**
         * a longer and more detail description of what the code is.
         */
        this.longDescription = undefined;
        /**
         * When the code takes effect. �Code is not deleted; the effective start date determines when the code is active.
         */
        this.effectiveStartDate = undefined;
        /**
         * When the code is not effective any longer. �Code is not deleted; the effective end date determines when the code is no longer active.
         */
        this.effectiveEndDate = undefined;
        /**
         * Action specific to the ref standard code maintenance activity.
         */
        this.actionCode = undefined;
        /**
         * Message specific to the ref standard code maintenance activity.
         */
        this.errorMessage = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkInfrastructureModule, InfrastructureApiService, ValidatePrinterGroupOrPrinterCodesResp, ValidatePrinterGroupOrPrinterCodesRqst, AddPrinterResp, AddPrinterRqst, AttachPrinterToGroupRqst, DeletePrinterGroupRqst, DeletePrinterRqst, GetLoggedInUserInfoResp, ListAttachedPrintersResp, ListAttachedPrintersRqst, ListPrinterGroupsResp, ListPrinterGroupsRqst, ListPrintersRqst, ListPrintersResp, ListRefStandardCodesResp, ListRefStandardCodesRqst, MaintainRefStandardCodesResp, MaintainRefStandardCodesRqst, RemovePrinterFromGroupRqst, UpdatePrinterGroupRqst, UpdatePrinterRqst, AddPrinterGroupResp, AddPrinterGroupRqst, CreateAsyncReportRqst, CreateAsyncReportResp, SendEmailRqst, PrintDocumentRqst, PrinterGroup, Printer, RefStandardCode };

